export type FormFieldType = 'TEXT' | 'TEXTAREA' | 'EMAIL' | 'PHONE' | 'SELECT' | 'MULTISELECT' | 'RATING';

export interface RatingFieldOptions {
  label_low?: string;  // Label for 1 star (e.g., "Schlecht")
  label_high?: string; // Label for 5 stars (e.g., "Ausgezeichnet")
}

export type LeadTypeDefault = 'CUSTOMER' | 'PARTNER' | 'NONE';

export interface Form {
  id: string;
  user_id: string;
  name: string;
  description: string | null;
  slug: string;
  is_published: boolean;
  is_system: boolean;
  lead_type_default: LeadTypeDefault;
  default_status: string | null;
  default_source: string | null;
  created_at: string;
  updated_at: string;
}

export interface FormField {
  id: string;
  form_id: string;
  user_id: string;
  type: FormFieldType;
  label: string;
  placeholder: string | null;
  required: boolean;
  options: string[] | RatingFieldOptions | null;
  field_order: number;
  field_key: string;
}

export interface FormSubmission {
  id: string;
  form_id: string;
  user_id: string;
  lead_id: string | null;
  submitted_at: string;
}

export interface FormAnswer {
  id: string;
  submission_id: string;
  form_field_id: string;
  value: string;
}

export interface FormWithFields extends Form {
  fields: FormField[];
}

export interface FormSubmissionWithAnswers extends FormSubmission {
  form?: Form;
  answers: (FormAnswer & { field?: FormField })[];
}

export interface CreateFormInput {
  name: string;
  description?: string;
  slug: string;
  is_published?: boolean;
  lead_type_default?: LeadTypeDefault;
  default_status?: string;
  default_source?: string;
}

export interface UpdateFormInput {
  name?: string;
  description?: string | null;
  slug?: string;
  is_published?: boolean;
  lead_type_default?: LeadTypeDefault;
  default_status?: string | null;
  default_source?: string | null;
}

export interface CreateFormFieldInput {
  form_id: string;
  type: FormFieldType;
  label: string;
  placeholder?: string;
  required?: boolean;
  options?: string[] | RatingFieldOptions;
  field_order: number;
  field_key: string;
}

export interface UpdateFormFieldInput {
  type?: FormFieldType;
  label?: string;
  placeholder?: string | null;
  required?: boolean;
  options?: string[] | RatingFieldOptions | null;
  field_order?: number;
  field_key?: string;
}

export const FIELD_TYPE_LABELS: Record<FormFieldType, string> = {
  TEXT: 'Text',
  TEXTAREA: 'Textfeld',
  EMAIL: 'E-Mail',
  PHONE: 'Telefon',
  SELECT: 'Auswahl',
  MULTISELECT: 'Mehrfachauswahl',
  RATING: 'Bewertung',
};

export const LEAD_TYPE_DEFAULT_LABELS: Record<LeadTypeDefault, string> = {
  NONE: 'Kein Lead erstellen',
  CUSTOMER: 'Kunde',
  PARTNER: 'Partner',
};
